<template>
	<div class="innerBox">
		<h1 class="mb-3">Income Statement</h1>
  
      	<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<div class="row outerBox filterBox" style="padding:0%">
				<div class="col row">
					<div class="col-md-3 col-12 mt-1" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Bulan</label>
						<Multiselect 
							:options="options.month.map(x => x.value)"
							:custom-label="opt => options.month.find(x => x.value == opt).name"
							v-model="selected.month"
							:allow-empty="false"
						/>
					</div>
					<div class="col-md-3 col-12 mt-1" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Tahun</label>
						<Multiselect 
							:options="options.year"
							v-model="selected.year"
							:allow-empty="false"
						/>
					</div>
					<div class="offset-md-3 col-md-3 col-12 mt-1" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
					<button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="update++">Filter</button>
					</div>
				</div>
			</div>
      	</panel>

		<div class="row mt-3">
			<div class="col-md-2 offset-md-10 col-sm-4 offset-sm-8 col-6 offset-6">
				<button class="btn btn-info w-100" @click="print">Print</button>
			</div>
		</div>

		<div class="mt-3 shadow rounded pl-5 pr-5" id="printMe">
			<div v-if="data && companyDetail" class="pt-4 pb-4 pl-5 pr-5">
				<h4>{{companyDetail.fullname.toUpperCase()}}</h4>
				<h4>Income Statement for Period {{moment().month(filter.month - 1).year(filter.year).startOf('month').format('MMMM DD, Y')}} Until {{moment().month(filter.month - 1).year(filter.year).endOf('month').format('MMMM DD, Y')}}</h4>
				<!-- {{data}} -->

				<div class="row mt-4">
					<div class="col-6 text-left mt-2">
						<p style="font-size:14px">Total Revenue</p>
					</div>

					<div class="col-6 text-right mt-2">
						<p style="font-size:14px">{{numberWithCommas(salesAmount)}}</p>
					</div>

					<div class="col-6 text-left mt-2">
						<p style="font-size:14px">Total Cost Of Goods Sold</p>
					</div>

					<div class="col-6 text-right mt-2">
						<p style="font-size:14px">{{numberWithCommas(costOfGoodSold)}}</p>
					</div>

					<div class="col-6 text-left mt-2 pt-2" >
						<h5>Gross Profit</h5>
					</div>

					<div class="col-3 offset-3 text-right mt-2 pt-2" style="border-top:1px solid black">
						<h5>{{numberWithCommas(salesAmount - costOfGoodSold)}}</h5>
					</div>
				</div>

				

				<div class="mt-4" v-for="category in data.filter(x => x.income_type)" :key="category.income_type">
					<hr>
					<h5>{{category.income_type}} EXPENSES</h5>

					<div class=" row" v-for="dat in data.filter(x => x.income_type == category.income_type)" :key="dat.type">
						<div class="col-6 text-left mt-2 pt-2" >
							<p style="font-size:14px">{{dat.type}}</p>
						</div>

						<div class="col-3 offset-3 text-right mt-2 pt-2">
							<p style="font-size:14px">{{numberWithCommas(dat.sum)}}</p>
						</div>
					</div>

					<div class=" row">
						<div class="col-6 text-left mt-2 pt-2" >
							<h5>Total {{category.income_type}} EXPENSES</h5>
						</div>

						<div class="col-3 offset-3 text-right mt-2 pt-2">
							<h5>{{sum(data.filter(x => x.income_type == category.income_type).map(x => x.sum))}}</h5>
						</div>
					</div>



				</div>

				
				<div class="mt-4">
					<hr>
					<div class="row ">
						<div class="col-6 text-left mt-2">
							<p style="font-size:14px">Income Before Tax</p>
						</div>

						<div class="col-6 text-right mt-2">
							<p style="font-size:14px">{{numberWithCommas(profitBeforeTax)}}</p>
						</div>

						<div class="col-6 text-left mt-2">
							<p style="font-size:14px">Income Tax ({{rangeTax.tax}}%)</p>
						</div>

						<div class="col-6 text-right mt-2">
							<p style="font-size:14px">{{numberWithCommas(taxAmount)}}</p>
						</div>

						<div class="col-6 text-left mt-2 pt-2" >
							<h5>Income After Tax</h5>
						</div>

						<div class="col-3 offset-3 text-right mt-2 pt-2" style="border-top:1px solid black">
							<h5>{{numberWithCommas(profit)}}</h5>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="pt-5 pb-5">
				<h4 class="text-center">Loading....</h4>
			</div>
		</div>
		  

	</div>
</template>

<script>
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
	components : {
		Multiselect
	},
	data () {
		let month = new moment().month()
		let year = new moment().year()

		return {
			options : this.$store.getters.getFilterOptions,
			filter : {
				year : year,
				month : month
			},
			selected : {
				year : year,
				month : month
			},
			mobile : this.isMobile(),
			update : 0,
			data : null,
			moment,
			companyDetail : null,
			costOfGoodSold : null,
			salesAmount : null,
			totalExpenses : null,
			rangeTax : null,
			profitBeforeTax : null,
			taxCategory : [{
				tax : 1,
				min : 0,
				max : 4800000000
			}, {
				tax : 12.5,
				min : 4800000001,
				max : 50000000000
			}, {
				tax : 25 ,
				min : 50000000001,
				max : 9999999999999
			}],
			profit: null,
			taxAmount : null
		}
	},
	mounted () {
		this.loadData()
		this.getCompanyDetail()
	},
	watch : {
		update : function () {
			this.filter.year = this.selected.year
			this.filter.month = this.selected.month

			this.loadData()
		}
	},
	methods : {
		print(){
			this.$htmlToPaper('printMe');
		},
		getCompanyDetail() {
			this.$http.get('/api/v1/company_profile')
			.then((resp)=>{
				this.companyDetail = resp.data.data;
			})
			.catch((err)=>{console.log(err);})
		},
		loadData() {
			
			this.$http.get(`/api/v1/transactions/income-statement?month=${this.filter.month}&year=${this.filter.year}`)
			.then((resp) => {
				this.data = resp.data.data[0]


				this.salesAmount = this.data.find(x => x.type == 'Sales')
				if(	!this.salesAmount || !this.salesAmount.sum) this.salesAmount = 0
				else this.salesAmount = parseFloat(this.salesAmount.sum)
				
				this.costOfGoodSold = this.data.find(x => x.type == 'Cost Of Goods Sold')
				if(!this.costOfGoodSold || !this.costOfGoodSold.sum) this.costOfGoodSold = 0
				else this.costOfGoodSold = parseFloat(this.costOfGoodSold.sum)

				this.totalExpenses = parseFloat(this.sum(this.data.filter(x => x.income_type).map(x => x.sum)).split(',').join(''))

				this.profitBeforeTax =  this.salesAmount - this.costOfGoodSold - this.totalExpenses

				this.rangeTax = this.taxCategory.find(x => x.min <= this.profitBeforeTax && x.max >= this.profitBeforeTax)
				this.taxAmount = this.profitBeforeTax * (this.rangeTax.tax / 100)
				this.profit = this.profitBeforeTax - this.taxAmount
				
			})
			.catch((err) => {
				console.log(err)
			})
		},
		sum(data) {
			let total = 0

			for(var i = 0 ; i < data.length ; i++) {
				total += data[i]
			}

			return this.numberWithCommas(total)
		}
	}
}
</script>